module.exports = __webpack_public_path__ + "e61448a11ff117b389d1a0fd3b5985d7.svg";